import { getToken } from "../authorization/auth";
import { API_ENDPOINT, APP_NAME, CN_METHOD } from "../authorization/const";

export function validDate(cn) {
}

export function validMethod(cn, method) {
    if(cn[0] === 'K' && method !== 'Express') return false;
    if(cn[0] === 'V' && method !== 'Premium') return false;
    if(cn[0] === 'D' && !(['Surface', 'Air'].includes(method))) return false;
    return CN_METHOD.includes(method);
}

export function validCn(cn) {
    if (cn === null) return false;
    else if (cn.length < 9 || cn.length > 12) return false;
    return /^(?:([A-Z]|7D)\d{8}|([A-Z]|7D|VD)\d{10})$/.test(cn);
}

export function validPrice(amt) {
    if (amt === "") return false;
    else if (Number(amt) < 0) return false;
    return true;
}

export function validPriceNeg(amt) {
    if (amt === "") return false;
    else if (Number(amt) === 0) return true;
    else if (!Number(amt)) return false;
    return true;
}

export function validPercentage(amt) {
    if (amt === "") return false;
    else if (Number(amt) < 0 || Number(amt) > 50) return false;
    return true;
}

export function validWeight(weight) {
    if (weight === "") return false;
    else if (Number(weight) === 0) return false;
    return weight % 1 === 0;
}

export function validIndianPin(pincode) {
    return !isNaN(Number(pincode)) && pincode.length === 6;
}

export async function getPinCodeJsr(pin) {
    if (document.getElementsByName("country")[0].value !== "India")
        throw new Error("Other country selected.");
    const res = await fetch(API_ENDPOINT + "booking/pin-code?pin=" + pin);
    if (res.status === 200) {
        var data = await res.json();
        document.getElementsByName("destination")[0].value = data[0].destination;
        document.getElementsByName("address")[0].value = data[0].destination + "\n" + data[0].state;
        return true
    }
    return false;
}

export function adjustFuelField() {
    const _dict = __get_form_data();
    let fuel_total = _dict.amount + _dict.pickup + _dict.packaging + _dict.other;
    _dict.fuel_rate = ((_dict.fuel / fuel_total) * 100).toFixed(2);
    _dict.subtotal = _dict.amount + _dict.pickup + _dict.packaging + _dict.other + _dict.fuel;
    __set_form_data(_dict);
    calcAmountField();
    return _dict;
}

export function adjustGstField() {
    const _dict = __get_form_data();
    _dict.gst_rate = ((_dict.gst / _dict.subtotal) * 100).toFixed(2);
    __set_form_data(_dict);
    calcAmountField();
    return _dict;
}

export function adjustSubTotalField() {
    const _dict = __get_form_data();
    if (_dict.is_fuel) {
        _dict.fuel = Number(((_dict.amount + _dict.pickup + _dict.packaging + _dict.other) * (_dict.fuel_rate / 100)).toFixed(2));
        let diffrance = Number((_dict.amount + _dict.pickup + _dict.packaging + _dict.other + _dict.fuel).toFixed(2)) - _dict.subtotal;
        diffrance = (diffrance * 100) / (100 + _dict.fuel_rate);
        _dict.other = Math.ceil((_dict.other - diffrance) * 100) / 100;
    } else {
        _dict.subtotal = _dict.total.toFixed(2);
    }
    __set_form_data(_dict);
    calcAmountField();
    return _dict;
}

export function adjustTotalField() {
    const _dict = __get_form_data();
    if (_dict.is_fuel)
        _dict.fuel = Number(((_dict.amount + _dict.pickup + _dict.packaging + _dict.other) * (_dict.fuel_rate / 100)).toFixed(2));
    else
        _dict.fuel = 0;
    if (_dict.is_gst)
        _dict.gst = Number(((_dict.amount + _dict.pickup + _dict.packaging + _dict.other + _dict.fuel) * (_dict.gst_rate / 100)).toFixed(2));
    else
        _dict.gst = 0;
    let diffrance = Number((_dict.amount + _dict.pickup + _dict.packaging + _dict.other + _dict.insurance + _dict.fuel + _dict.gst).toFixed(2)) - _dict.total;
    if (_dict.is_gst) {
        diffrance = (diffrance * 100) / (100 + _dict.gst_rate);
    }
    if (_dict.is_fuel) {
        diffrance = (diffrance * 100) / (100 + _dict.fuel_rate);
    }
    _dict.other = Math.ceil((_dict.other - diffrance) * 100) / 100;
    __set_form_data(_dict);
    calcAmountField();
    return _dict;
}

export function calcAmountField() {
    const _dict = __get_form_data();
    if (_dict.is_fuel)
        _dict.fuel = Number(((_dict.amount + _dict.pickup + _dict.packaging + _dict.other) * (_dict.fuel_rate / 100)).toFixed(2));
    else
        _dict.fuel = 0;
    if (_dict.is_gst)
        _dict.gst = Number(((_dict.amount + _dict.pickup + _dict.packaging + _dict.other + _dict.fuel) * (_dict.gst_rate / 100)).toFixed(2));
    else
        _dict.gst = 0;
    _dict.subtotal = Number((_dict.amount + _dict.pickup + _dict.packaging + _dict.other + _dict.fuel).toFixed(2));
    _dict.total = Number((_dict.amount + _dict.pickup + _dict.packaging + _dict.other + _dict.insurance + _dict.fuel + _dict.gst).toFixed(2));
    __set_form_data(_dict);
    return _dict;
}

/**
 * Get all client details
 * 
 * @param {string} request request window name (`booking`, `packaging`, `pickup`)
 * @returns 
 */
export async function getClientList(request) {
    const append = Boolean(request) || request === "" ? "?request=" + request : "";
    const res = await fetch(API_ENDPOINT + "client/get-all-names/" + getToken() + append);
    if (res.status === 200)
        return await res.json();
    throw new Error("No client records found.");
}

export async function getCnSuggestion() {
    const res = await fetch(API_ENDPOINT + "inventory/cn/suggestion/" + getToken());
    if (res.status === 200)
        return await res.json();
    throw new Error("No consignment records found.");
}


export async function getOrgCn() {
    const res = await fetch(API_ENDPOINT + "booking/cn-list/" + getToken());
    if (res.status === 200)
        return await res.json();
    throw new Error("No consignment records found.");
}

export async function getPickupCn() {
    const res = await fetch(API_ENDPOINT + "booking/pickup-list/" + getToken());
    if (res.status === 200)
        return await res.json();
    throw new Error("No consignment records found.");
}

export async function getPackagingCn() {
    const res = await fetch(API_ENDPOINT + "booking/packaging-list/" + getToken());
    if (res.status === 200)
        return await res.json();
    throw new Error("No consignment records found.");
}

function __get_form_data() {
    const data = {
        "amount": Number(document.getElementsByName("amount")[0].value) || 0,
        "pickup": Number(document.getElementsByName("pickup")[0].value) || 0,
        "packaging": Number(document.getElementsByName("packaging")[0].value) || 0,
        "other": Number(document.getElementsByName("other")[0].value) || 0,
        "insurance": Number(document.getElementsByName("insurance")[0].value) || 0,
        "fuel": Number(document.getElementsByName("fuel")[0].value) || 0,
        "gst": Number(document.getElementsByName("gst")[0].value) || 0,
        "total": Number(document.getElementsByName("total")[0].value) || 0,
        "is_gst": document.getElementsByName("is_gst")[0].checked,
        "gst_rate": Number(document.getElementsByName("gst_rate")[0].value) || 0,
        "is_fuel": document.getElementsByName("is_fuel")[0].checked,
        "fuel_rate": Number(document.getElementsByName("fuel_rate")[0].value) || 0,
        "subtotal": Number(document.getElementsByName("subtotal")[0].value) || 0
    }
    return data;
}

function __set_form_data(_dict) {
    document.getElementsByName("amount")[0].value = _dict['amount'];
    document.getElementsByName("pickup")[0].value = _dict['pickup'];
    document.getElementsByName("packaging")[0].value = _dict['packaging'];
    document.getElementsByName("other")[0].value = _dict['other'];
    document.getElementsByName("insurance")[0].value = _dict['insurance'];
    document.getElementsByName("fuel")[0].value = _dict['fuel'];
    document.getElementsByName("gst")[0].value = _dict['gst'];
    document.getElementsByName("is_gst")[0].checked = _dict['is_gst'];
    document.getElementsByName("gst_rate")[0].value = _dict['gst_rate'];
    document.getElementsByName("is_fuel")[0].checked = _dict['is_fuel'];
    document.getElementsByName("fuel_rate")[0].value = _dict['fuel_rate'];
    document.getElementsByName("total")[0].value = _dict['total'];
    document.getElementsByName("subtotal")[0].value = _dict['subtotal'];
}

export function set_cn_number(num) {
    document.getElementsByName("cn_no")[0].value = num;
}

export async function dayBooking(data) {
    data["auth"] = getToken();
    data["appname"] = APP_NAME;
    const res = await fetch(API_ENDPOINT + "booking/day-cn/new", {
        method: "POST",
        body: JSON.stringify(data)
    });
    if (res.status === 200)
        return await res.json();
    throw await res.json();
}

export async function orgBooking(data) {
    data["auth"] = getToken();
    data["appname"] = APP_NAME;
    const res = await fetch(API_ENDPOINT + "booking/org-cn/new", {
        method: "POST",
        body: JSON.stringify(data)
    });
    if (res.status === 200)
        return await res.json();
    throw await res.json();
}

export async function insuranceBooking(data) {
    data["auth"] = getToken();
    const res = await fetch(API_ENDPOINT + "booking/insurance/new", {
        method: "POST",
        body: JSON.stringify(data)
    });
    if (res.status === 200)
        return await res.json();
    throw await res.json();
}

export async function pickupBooking(data) {
    data["auth"] = getToken();
    const res = await fetch(API_ENDPOINT + "booking/pickup/new", {
        method: "POST",
        body: JSON.stringify(data)
    });
    if (res.status === 200)
        return await res.json();
    throw await res.json();
}


export async function packagingBooking(data) {
    data["auth"] = getToken();
    const res = await fetch(API_ENDPOINT + "booking/packaging/new", {
        method: "POST",
        body: JSON.stringify(data)
    });
    if (res.status === 200)
        return await res.json();
    throw await res.json();
}


/**
 * Get consignment details
 * 
 * @param {string} cn Consignment number
 * @param {desk|org} counter Booking counter name
 * @returns Consignment details as JSON
 */
export async function getConsignment(cn, counter) {
    if (!["desk", "org"].includes(counter)) {
        throw Error("Invalid booking counter.");
    }
    const res = await fetch(API_ENDPOINT + "booking/details/" + getToken() + "?cn=" + cn + "&counter=" + counter);
    if (res.status === 200)
        return await res.json();
    throw await res.json();
}

export async function getPickup(cn) {
    const res = await fetch(API_ENDPOINT + "booking/pickup/all/" + cn + "/" + getToken());
    __set_form_data_pickup({ "pickup": 0, "is_gst": false, "gst_rate": 18, "gst": 0, "is_fuel": false, "fuel_rate": 35, "fuel": 0, "total": 0 });
    if (res.status === 200) {
        const data = await res.json();
        __set_form_data_pickup({ "pickup": 0, "is_gst": data['gst'] !== 0, "gst_rate": data['gst'], "gst": 0, "is_fuel": data['fuel'] !== 0, "fuel_rate": data['fuel'], "fuel": 0, "total": 0 });
        return [data['fuel'], data['gst'], data['tax_lock'], data['data']];
    } else if (res.status === 404) {
        return [0, 0, false, []];
    }
    throw new Error("Invalid response from server.");
}

export async function getPackaging(cn) {
    const res = await fetch(API_ENDPOINT + "booking/packaging/all/" + cn + "/" + getToken());
    __set_form_data_packaging({ "pickup": 0, "is_gst": false, "gst_rate": 18, "gst": 0, "is_fuel": false, "fuel_rate": 35, "fuel": 0, "total": 0 });
    if (res.status === 200) {
        const data = await res.json();
        __set_form_data_packaging({ "packaging": 0, "is_gst": data['gst'] !== 0, "gst_rate": data['gst'], "gst": 0, "is_fuel": data['fuel'] !== 0, "fuel_rate": data['fuel'], "fuel": 0, "total": 0 });
        return [data['fuel'], data['gst'], data['tax_lock'], data['data']];
    } else if (res.status === 404) {
        return [0, 0, false, []];
    }
    throw new Error("Invalid response from server.");
}

export async function getInsurance(cn) {
    const res = await fetch(API_ENDPOINT + "booking/insurance/all/" + cn + "/" + getToken());
    if (res.status === 200) {
        return await res.json();
    } else if (res.status === 404) {
        return [];
    }
    throw new Error("Invalid response from server.");
}

export function adjustPickupTotalField() {
    const _dict = __get_form_data_pickup();
    if (_dict.is_fuel)
        _dict.fuel = Number((_dict.pickup * (_dict.fuel_rate / 100)).toFixed(2));
    else
        _dict.fuel = 0;
    if (_dict.is_gst)
        _dict.gst = Number(((_dict.pickup + _dict.fuel) * (_dict.gst_rate / 100)).toFixed(2));
    else
        _dict.gst = 0;

    let diffrance = Number((_dict.pickup + _dict.fuel + _dict.gst).toFixed(2)) - _dict.total;
    if (_dict.is_gst) {
        diffrance = (diffrance * 100) / (100 + _dict.gst_rate);
    }
    if (_dict.is_fuel) {
        diffrance = (diffrance * 100) / (100 + _dict.fuel_rate);
    }
    _dict.pickup = Math.ceil((_dict.pickup - diffrance) * 100) / 100;
    __set_form_data_pickup(_dict);
    calcPickupField();
    return _dict;
}

export function adjustPickupFuelField() {
    const _dict = __get_form_data_pickup();
    _dict.fuel_rate = ((_dict.fuel / _dict.pickup) * 100).toFixed(2);
    __set_form_data_pickup(_dict);
    calcPickupField();
    return _dict;
}

export function adjustPickupGstField() {
    const _dict = __get_form_data_pickup();
    let subtotal = _dict.pickup + _dict.fuel
    _dict.gst_rate = ((_dict.gst / subtotal) * 100).toFixed(2);
    __set_form_data_pickup(_dict);
    calcPickupField();
    return _dict;
}

export function calcTotalDesk(item) {
    const total = item.amount + item.other + item.packaging + item.pickup + item.fuel + item.gst + item.insurance;
    return total.toFixed(2);

}

export function calcPickupField() {
    const _dict = __get_form_data_pickup();
    if (_dict.is_fuel)
        _dict.fuel = Number((_dict.pickup * (_dict.fuel_rate / 100)).toFixed(2));
    else
        _dict.fuel = 0;
    if (_dict.is_gst)
        _dict.gst = Number(((_dict.pickup + _dict.fuel) * (_dict.gst_rate / 100)).toFixed(2));
    else
        _dict.gst = 0;
    _dict.total = Number((_dict.pickup + _dict.fuel + _dict.gst).toFixed(2));
    __set_form_data_pickup(_dict);
    return _dict;
}

export function reset_tax(_dict) {
    document.getElementsByName("gst_rate")[0].value = 18;
    document.getElementsByName("gst")[0].value = 0;
    document.getElementsByName("fuel_rate")[0].value = 35;
    document.getElementsByName("fuel")[0].value = 0;
}

function __set_form_data_pickup(_dict) {
    document.getElementsByName("pickup")[0].value = _dict['pickup'];
    document.getElementsByName("is_gst")[0].checked = _dict['is_gst'];
    document.getElementsByName("gst_rate")[0].value = _dict['gst_rate'];
    document.getElementsByName("gst")[0].value = _dict['gst'];
    document.getElementsByName("is_fuel")[0].checked = _dict['is_fuel'];
    document.getElementsByName("fuel_rate")[0].value = _dict['fuel_rate'];
    document.getElementsByName("fuel")[0].value = _dict['fuel'];
    document.getElementsByName("total")[0].value = _dict['total'];
}

function __get_form_data_pickup(_dict) {
    const data = {
        "pickup": Number(document.getElementsByName("pickup")[0].value),
        "is_gst": document.getElementsByName("is_gst")[0].checked,
        "gst_rate": Number(document.getElementsByName("gst_rate")[0].value),
        "gst": Number(document.getElementsByName("gst")[0].value),
        "is_fuel": document.getElementsByName("is_fuel")[0].checked,
        "fuel_rate": Number(document.getElementsByName("fuel_rate")[0].value),
        "fuel": Number(document.getElementsByName("fuel")[0].value),
        "total": Number(document.getElementsByName("total")[0].value),
    }
    return data;
}

export function adjustPackagingTotalField() {
    const _dict = __get_form_data_packaging();
    if (_dict.is_fuel)
        _dict.fuel = Number((_dict.packaging * (_dict.fuel_rate / 100)).toFixed(2));
    else
        _dict.fuel = 0;
    if (_dict.is_gst)
        _dict.gst = Number(((_dict.packaging + _dict.fuel) * (_dict.gst_rate / 100)).toFixed(2));
    else
        _dict.gst = 0;

    let diffrance = Number((_dict.packaging + _dict.fuel + _dict.gst).toFixed(2)) - _dict.total;
    if (_dict.is_gst) {
        diffrance = (diffrance * 100) / (100 + _dict.gst_rate);
    }
    if (_dict.is_fuel) {
        diffrance = (diffrance * 100) / (100 + _dict.fuel_rate);
    }
    _dict.packaging = Math.ceil((_dict.packaging - diffrance) * 100) / 100;
    __set_form_data_packaging(_dict);
    calcPackagingField();
    return _dict;
}

export function adjustPackagingFuelField() {
    const _dict = __get_form_data_packaging();
    _dict.fuel_rate = ((_dict.fuel / _dict.packaging) * 100).toFixed(2);
    __set_form_data_packaging(_dict);
    calcPackagingField();
    return _dict;
}

export function adjustPackagingGstField() {
    const _dict = __get_form_data_packaging();
    let subtotal = _dict.packaging + _dict.fuel
    _dict.gst_rate = ((_dict.gst / subtotal) * 100).toFixed(2);
    __set_form_data_packaging(_dict);
    calcPackagingField();
    return _dict;
}

export function calcPackagingField() {
    const _dict = __get_form_data_packaging();
    if (_dict.is_fuel)
        _dict.fuel = Number((_dict.packaging * (_dict.fuel_rate / 100)).toFixed(2));
    else
        _dict.fuel = 0;
    if (_dict.is_gst)
        _dict.gst = Number(((_dict.packaging + _dict.fuel) * (_dict.gst_rate / 100)).toFixed(2));
    else
        _dict.gst = 0;
    _dict.total = Number((_dict.packaging + _dict.fuel + _dict.gst).toFixed(2));
    __set_form_data_packaging(_dict);
    return _dict;
}

function __set_form_data_packaging(_dict) {
    document.getElementsByName("packaging")[0].value = _dict['packaging'];
    document.getElementsByName("is_gst")[0].checked = _dict['is_gst'];
    document.getElementsByName("gst_rate")[0].value = _dict['gst_rate'];
    document.getElementsByName("gst")[0].value = _dict['gst'];
    document.getElementsByName("is_fuel")[0].checked = _dict['is_fuel'];
    document.getElementsByName("fuel_rate")[0].value = _dict['fuel_rate'];
    document.getElementsByName("fuel")[0].value = _dict['fuel'];
    document.getElementsByName("total")[0].value = _dict['total'];
}

function __get_form_data_packaging(_dict) {
    const data = {
        "packaging": Number(document.getElementsByName("packaging")[0].value),
        "is_gst": document.getElementsByName("is_gst")[0].checked,
        "gst_rate": Number(document.getElementsByName("gst_rate")[0].value),
        "gst": Number(document.getElementsByName("gst")[0].value),
        "is_fuel": document.getElementsByName("is_fuel")[0].checked,
        "fuel_rate": Number(document.getElementsByName("fuel_rate")[0].value),
        "fuel": Number(document.getElementsByName("fuel")[0].value),
        "total": Number(document.getElementsByName("total")[0].value),
    }
    return data;
}

export async function deleteInsurance(data) {
    data["auth"] = getToken();
    const res = await fetch(API_ENDPOINT + "booking/insurance/delete", {
        method: "DELETE",
        body: JSON.stringify(data)
    });
    if (res.status === 200)
        return await res.json();
    throw await res.json();
}

export async function deletePickup(data) {
    data["auth"] = getToken();
    const res = await fetch(API_ENDPOINT + "booking/pickup/delete", {
        method: "DELETE",
        body: JSON.stringify(data)
    });
    if (res.status === 200)
        return await res.json();
    throw await res.json();
}

export async function deletePackaging(data) {
    data["auth"] = getToken();
    const res = await fetch(API_ENDPOINT + "booking/packaging/delete", {
        method: "DELETE",
        body: JSON.stringify(data)
    });
    if (res.status === 200)
        return await res.json();
    throw await res.json();
}
